import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_DASHBOARD } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";

const Dashboard = lazy(() => import("../pages/dashboard/dashboard.container"));

const dashboardRoutes = [
  {
    path: PATH_DASHBOARD,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <Dashboard />,
        index: true,
      },
    ],
  },
];

export default dashboardRoutes;
